/**
 * Created by Olga on 22.05.2025
 */

cleverapps.override(cleverapps.EVENTS, {
    LOCATION_FIX: "location_fix",
    LOCATION_ORDER: "location_order",
    ROOM_COMPLETED: "room_completed",

    BACKPACK_AVAILABLE: "bpk_available",
    BACKPACK_USE: "bpk_use",
    BACKPACK_INSERT: "bpk_insert",
    BACKPACK_EXTRACT: "bpk_extract",
    BACKPACK_UNLOCK: "bpk_unlock",
    BACKPACK_FULLNESS: "bpk_full",
    BACKPACK_CAPACITY: "bpk_capacity",

    EARN: {
        FIX_REWARD: "fix_reward"
    }
});